<template>
    <div class="charge-center-container">
        <div class="charge-center__header m-b text-center">
            {{ $t('充值中心') }}
        </div>
        <template v-if="hidePayForm">
            <div class="p-lg text-center">
                <div style="color: #888" class="m-b-lg">{{ $t('充值金额') }}</div>
                <div style="font-size: 54px;font-weight: 600" class="m-b-lg">
                    ${{ payForm.order_money | priceFilter }}
                </div>
                <div style="color: #888" class="m-t">
                    {{ $t('充值已受理，到账结果以游戏中为准') }}
                </div>
                <div class="m-t">
                    <button class="btn btn-block btn-primary" v-show="hideRerurnGame" @click="paymentClose" >
                        {{ $t('返回游戏') }}
                    </button>
                    <button class="btn btn-block btn-primary" v-show="hideSafariRerurnGame" @click="returnGame" >
                        {{ $t('返回游戏') }}
                    </button>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="p-md">
                <cell class="cell-container" :title="`${$t('充值金额')}：`">
                    {{ payForm.order_money | priceFilter }} {{ $t('元') }}
                </cell>
                <radio-group :disabled="paymentProcessing" v-model="payForm.pay_type" class="m-t-lg m-b-lg">
                    <template v-for="method in availablePayment">
                        <cell :key="method.value" class="m-b cell-container" @click="selectPayMethod(method)">
                            <template v-slot:title>
                                <div class="flex-row flex-center-left">
                                    <img v-if="method.image" :src="method.image" class="custom-pay-icon" />
                                    <icon v-else size="28" :name="method.icon" :color="method.color"></icon>
                                    <span class="m-l">{{ method.label }}</span>
                                </div>
                            </template>
                            <template v-slot:right-icon>
                                <radio
                                    checked-color="var(--theme-color)"
                                    :name="method.value"
                                ></radio>
                            </template>
                        </cell>
                    </template>
                </radio-group>
                <button
                    class="btn btn-block btn-primary"
                    :disabled="paymentProcessing || payForm.pay_type === ''"
                    @click="confirmPayment"
                >
                    <span class="flex-row flex-center">
                         <van-loading size="12" v-show="paymentProcessing"/>
                        &nbsp;
                        {{ $t('确认支付') }}
                    </span>
                </button>
                <span></span>
                <button class="btn btn-block btn-info m-t" :disabled="paymentProcessing" @click="paymentClose">
                    {{ $t('取消') }}
                </button>
                <div class="c-title" v-if="couponList.length > 0">
                    {{ $t('可用优惠券') }}：
                    <span v-if="!!curCoupon">{{ $t('已选择1张优惠券') }}</span>
                </div>
                <div class="card-container" v-if="couponList.length > 0">
                    <div
                        v-for="item in couponList"
                        :key="item.id"
                        @click="clickCoupon(item)"
                        :class="curCoupon == item.id ? 'card c-check' : 'card'"
                    >
                        <div class="card-left">
                            <div class="left-body">
                                <div class="left-money orange">
                                    <span>{{ item.discount_money }}</span>
                                    <span class="currency">{{ $t('元') }}</span>
                                </div>
                                <div class="left-tip">满{{ item.condition }}减{{ item.discount_money }}</div>
                            </div>
                            </div>
                                <div class="card-right">
                            <div>
                                <span class="right-title">{{ item.describe }}</span>
                                <van-tag v-if="item.coupon_type == 2" type="warning" size="medium">{{ $t('新人券') }}</van-tag>
                                <van-tag v-if="item.coupon_type == 1" type="success" size="medium">{{ $t('普通券') }}</van-tag>
                            </div>
                            <div class="right-time" v-if="item.coupon_type == 1">
                                {{ item.effective_etime }}
                            </div>
                            <div class="right-time" v-if="item.coupon_type == 2">
                                {{ item.effective_day || item.effective_etime }}
                            </div>
                        </div>
                        <icon name="checked" color="#c49947" size="36" v-if="curCoupon == item.id" />
                    </div>
                    <div class="b-text" v-if="couponList.length > 0">-- {{ $t('已经到底了') }} --</div>
                </div>
                <van-popup v-model="showAdyenPay" closeable round position="bottom" @closed="paymentClose" :style="{ height: '90%' }">
                    <div :style="{ height: '50px' }" />
                    <div id="adyen-jh-payment" />
                    <van-loading v-if="adyenLoading" size="24px" vertical color="#1989fa" text-color="#0094ff">Loading...</van-loading>
                </van-popup>
                <van-popup v-model="showModalPay" closeable round position="bottom" @closed="paymentClose" :style="{ height: '90%', display: 'flex', 'flex-direction': 'column' }">
                    <div :style="{ height: '50px' }" />
                    <van-loading v-if="modalPayLoading" size="24px" vertical color="#1989fa" text-color="#0094ff">Loading...</van-loading>
                    <iframe
                        v-if="showModalPay"
                        :src="modalPayUrl"
                        frameborder="0"
                        sandbox="allow-forms allow-scripts allow-same-origin allow-popups"
                        style="width: 100%; height: 100%; border: 0; flex: 1;"
                        @load="modalPayLoading = false"
                    ></iframe>
                </van-popup>
            </div>
        </template>
    </div>
</template>

<script>
import { Cell, Icon, Loading, Radio, RadioGroup, Tag as VanTag, Popup as VanPopup } from 'vant'
import { translateUrlParams, getParams, serialize } from '@/utils/url'
import { baseApiURL } from '@/utils/properties'
import { getLocalAccountData, getLocalAppConfig, setLocalAppConfig, setLocalAccountData, } from '@/utils/storage'
import { getPayType, useableCouponReq } from '@/service'
import { mapState } from 'vuex'
import api from '@/utils/api'
import browser, { platform } from '@/utils/browser'
import { $t } from '@/utils/languages'
import adyenIcon from '@/assets/adyen-icon.png'


const isWechatEnv = typeof WeixinJSBridge !== 'undefined' || typeof window.parent.WeixinJSBridge !== 'undefined' ||
    `${getParams('isWechatEnv')}` === '1'

console.log('isWechatEnv', isWechatEnv)
console.log('browser', browser.isSafari)

function postMessageToParent(message) {
    if (window.parent) {
        window.parent.postMessage(message, '*')
    }
}

export default {
    name: 'ChargeCenter',
    components: {
        VanLoading: Loading,
        Cell,
        Icon,
        Radio,
        RadioGroup,
        VanTag,
        VanPopup,
    },
    data() {
        return {
            payMethods: [
                {
                    label: 'Credit Card (97% discount)', // Adyen支付
                    image: adyenIcon,
                    value: 'adyen',
                    color: '#57bb60',
                },
                {
                    label: 'Local Payment', // PayerMax
                    icon: 'gold-coin',
                    value: 'payermax',
                    color: '#4b80f7',
                },
                {
                    label: 'Xsolla',
                    icon: 'card',
                    value: 'xsolla',
                    color: '#ea335e',
                },
            ],
            payForm: {
                pay_type: '',
            },
            paymentProcessing: false,
            hidePayForm: true,
            hideRerurnGame: isWechatEnv,
            hideSafariRerurnGame: browser.isSafari,
            curCoupon: '',
            couponList: [], // 可用优惠券
            showAdyenPay: false,
            adyenLoading: false,
            showModalPay: false,
            modalPayLoading: false,
            modalPayUrl: '',
        }
    },
    computed: {
        gameFrame() {
            return this.$store.state.gameFrameInfo.frame
        },
        ...mapState({
            paymentConfig: state => state.app.paymentConfig,
        }),
        availablePayment() {
            console.log('this.payment', this.paymentConfig)
            return this.payMethods.filter(item => {
                if(browser.isPC){
                    return this.paymentConfig[item.value] && this.paymentConfig[item.value] !== '' && item.value !== 'wx'
                }else{
                    return this.paymentConfig[item.value] && this.paymentConfig[item.value] !== ''
                }
            })
        },
    },
    watch: {
        availablePayment: {
            deep: true,
            handler() {
                let payType = ''
                if (this.availablePayment.filter(item => item.value === 'adyen').length) {
                    payType = 'adyen'
                } else if (this.payForm.pay_type === '' && this.availablePayment.length > 0) {
                    payType = this.availablePayment[0].value
                }
                this.$set(this.payForm, 'pay_type', payType)
            },
        },
        paymentConfig() {
            this.setDefaultAlipay()
        },
    },
    methods: {
        setDefaultAlipay() {
            console.log('set default adyen')
            if (this.paymentConfig.adyen !== '') {
                this.$set(this.payForm, 'pay_type', 'adyen')
            }
        },
        selectPayMethod(method) {
            this.payForm.pay_type = method.value
        },
        paymentClose() {
            // 2025.08.25 回传安卓壳包关闭支付页面事件
            try {
                window?.JsJingYouNativeBridge?.closeView?.()
                console.log('JsJingYouNativeBridge.closeView<Android> | closeView - pay >>> ')
            } catch (err) {
                console.error('>>> post Android payment closeView fail', err)
            }

            // 原关闭支付页面逻辑
            postMessageToParent({
                key: 'closePayment',
                value: true,
            })
        },
        returnGame(){
            window.close()
        },
        async confirmPayment() {
            const payType = this.payForm.pay_type

            if (this.paymentProcessing) {
                return false
            }

            // 安卓的Adyen支付用浏览器打开
            // if (
            //     payType === 'adyen' &&
            //     browser.isAndroid &&
            //     !getParams('is_charge_center') &&
            //     window?.top?.JsJingYouNativeBridge?.payOther instanceof Function
            // ) {
            //     try {
            //         const prm = {
            //             ...getLocalAppConfig(),
            //             ...getLocalAccountData(),
            //             ...this.$store.state.appConfig,
            //             ...this.$store.state.accountData,
            //             ...this.payForm
            //         }
            //         const paramsStr = serialize(prm)
            //         const payUrlParams = `https://h5sdkxk.3698k.com/chargeCenter?is_charge_center=true&${paramsStr}`
            //         console.log('JsJingYouNativeBridge.pay<Android> | payOther open url | adyen >>> ', payUrlParams)
            //         window.top.JsJingYouNativeBridge.payOther(payUrlParams)
            //     } catch (err) {
            //         console.error(err)
            //     }
            //     return false
            // }

            try {
                this.paymentProcessing = true
                const {
                    appConfig = getLocalAppConfig(),
                    accountData = getLocalAccountData(),
                } = this.$store.state

                const query = {
                    muid: appConfig.muid || getParams('muid'),
                    game_id: appConfig.game_id || getParams('game_id'),
                    platform: appConfig.platform,
                    username: accountData.username || getParams('username'),
                    user_token: accountData.user_token,
                    reg_time: accountData.reg_time,
                    debug: 'development',
                    is_pc: browser.isPC  ? 1 : 0,
                    coupon_id: this.curCoupon,
                    ...this.payForm,
                }
                console.log('query', query)

                // 2022.04.11 回传支付数据给安卓端
                try {
                    const payInfos = JSON.stringify({
                        amount: query?.order_money || '',
                        orderId: query?.ext || '', // 对应cp订单号
                        userName: query?.username || '',
                    })
                    window?.JHJsImpl?.submitPayInfo?.(payInfos)
                    console.log('JHJsImpl.submitPayInfo<Android> | pay >>> ', payInfos)

                    // 2024.01.16 回传支付参数到新安卓壳包
                    if (window?.JsJingYouNativeBridge?.jsJingYouPay) {
                        postMessageToParent({
                            key: 'JsJingYouNativeBridgeOfPayInfo',
                            value: {
                                ...query,
                                thePaytype: this.payForm?.pay_type === 'wx' || this.payForm?.pay_type === 'inner_wx' ? '微信' : '支付宝'
                            },
                        })
                    }

                    // 2025.09.14 回传ios壳包 - 支付
                    if (window?.webkit?.messageHandlers?.ios_appledata) {
                        postMessageToParent({
                            key: 'JsJingYouNativeBridgeOfPayInfo',
                            value: { ...query },
                        })
                    }
                } catch (err) {
                    console.log('回传安卓端失败：', err)
                }


                /** ---------- PayerMax / Xsolla支付流程（走链接支付） -------- */
                let url = '/WapPay/hwH5Pay?'
                Object.entries(query).forEach(([key, value]) => {
                    url = `${url}&${key}=${value}`
                })
                console.log('payment url', url)

                // 走链接支付
                api.get(url, {
                    messageSilent: true,
                }).then(async (res) => {
                    console.log('>>> payermax res', res)
                    if (Number(res.code) === 0) {
                        if (res.data?.pay_url) {
                            console.log('>>>> modalPay res.data.pay_url', res.data.pay_url)
                            this.modalPayLoading = true
                            this.modalPayUrl = res.data.pay_url
                            this.showModalPay = true
                        } else if (payType === 'adyen') {
                            this.onAdyenPay(query, res)
                        } else {
                            this.$toast(res.msg || $t('支付链接不存在'))
                        }
                        // else if (res.data?.pay_url) {
                        //     console.log('>>>> res.data.pay_url', res.data.pay_url)
                        //     if (browser.isAndroid) {
                        //         // 安卓壳包用 payOther打开外链支付
                        //         try {
                        //             // 走链接支付
                        //             if (window?.top?.JsJingYouNativeBridge?.payOther instanceof Function) {
                        //                 const payUrlParams = res.data.pay_url || ''
                        //                 // 2025.05.08 新安卓壳包打开支付外链
                        //                 window.top.JsJingYouNativeBridge.payOther(payUrlParams)
                        //                 console.log('JsJingYouNativeBridge.pay<Android> | payOther open url >>> ', payUrlParams)
                        //             } else {
                        //                 window.top.open(res.data.pay_url, "_blank");
                        //             }
                        //         } catch (err) {
                        //             console.error('>>> open android url fail', err)
                        //             window.top.open(res.data.pay_url, "_blank");
                        //         }
                        //     } else if (browser.isiOS) {
                        //         // iOS支付
                        //         window.top.location.href = res.data.pay_url;
                        //     } else {
                        //         // PC端
                        //         window.top.open(res.data.pay_url, "_blank");
                        //     }
                        //     this.paymentClose();
                        // }
                    } else {
                        this.$toast(res.msg || $t('支付失败'))
                    }
                }).catch((error)=>{
                    console.error(error)
                }).finally(() => {
                    this.paymentProcessing = false
                })
            } catch (e) {
                this.paymentProcessing = false
                console.log('something went wrong', e)
                this.$toast($t('支付异常，请重试'))
            }
        },
        async onAdyenPay(query, res) {
            this.showAdyenPay = true
            this.adyenLoading = true
            try {
                const { AdyenCheckout, Dropin } = window.AdyenWeb;
                const sessionString = res.data.session;
                const session = JSON.parse(sessionString);

                const configuration = {
                    environment: 'live', // live正式 test测试
                    clientKey: session.clientKey,
                    session: {
                        id: session.sessionId,
                        sessionData: session.sessionData
                    },
                    countryCode: 'US',
                    locale: 'en-US',
                    amount: {
                        value: session.money,
                        currency: 'USD'
                    },
                    onPaymentCompleted: (result, component) => {
                        if (result.resultCode === 'Authorised' || result.resultCode === 'Received') {
                            this.$dialog.alert({
                                message: 'Payment successful!',
                                zIndex: 999999999
                            })
                            // 2秒后关闭支付弹窗
                            setTimeout(() => {
                                this.showAdyenPay = false
                            }, 2000)
                        } else {
                            this.$toast($t('支付失败'))
                        }
                    },
                    onPaymentFailed: (result, component) => {
                        this.$toast($t('支付失败'))
                    },
                    onError: (error, component) => {
                        this.$toast($t('支付失败'))
                    }
                }

                // 创建AdyenCheckout实例
                let checkout = await AdyenCheckout(configuration);

                // 创建并挂载Drop-in
                let dropin = new Dropin(checkout, {
                    instantPaymentTypes: ['applepay'], // TODO 这里要不要其他支付
                }).mount('#adyen-jh-payment');

                // this.showAdyenPay = true
                setTimeout(() => {
                    this.adyenLoading = false;
                }, 3000)
            } catch (err) {
                this.$toast($t('支付异常，请重试'))
            }
        },
        clickCoupon(item) {
            if (this.curCoupon == item.id) {
                this.curCoupon = ''
            } else {
                this.curCoupon = item.id
            }
        },
        doGetCouponList() {
            const params = {
                order_money: getParams('order_money'),
            }
            useableCouponReq(params).then((res) => {
                if (`${res?.code}` === '0') {
                    this.couponList = res?.data || []
                } else {
                    this.$toast(res?.msg || $t('获取可用优惠券失败'))
                }
            }).catch(() => {
                this.$toast($t('获取可用优惠券失败'))
            })
        },
    },
    filters: {
        priceFilter(price) {
            if (Number(price) >= 0) {
                if (['1113068', '1113065', '1113067'].includes(`${getParams('game_id')}`)) {
                    // 变小100倍展示，即 6元显示成 0.06元
                    try {
                        const minPrice = Number(price) / 100
                        return Number(minPrice).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
                    } catch (e) {
                        return price
                    }
                }
                // 以下为原逻辑
                return Number(price).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
            } else if (price) {
                return price
            } else {
                return '-'
            }
        },
    },
    mounted() {
        if (process.env.NODE_ENV === 'development') this.doGetCouponList() // 测试
        if (window.location.protocol === 'http:') {
            //    当为http协议下打开支付中心时，提醒更换HTTPS SSL协议
            this.$dialog.alert({
                title: $t('提示'),
                message: $t('支付中心必须使用SSL协议，如有问题，请联系技术人员'),
                beforeClose: (action, done) => {
                    postMessageToParent({ key: 'reLogin', value: true })
                    // window.postMessage({ key: 'reLogin', value: true }, '*')
                    done()
                },
            })
        } else if (getParams('is_charge_center')) { // 适配单独的 html支付页面
            const localAppConfig = getLocalAppConfig()

            // 适配 appConfig逻辑
            const appConfig = {
                bg: getParams('bg') || localAppConfig.bg || '',
                game: getParams('game') || localAppConfig.game || '',
                muid: getParams('muid') || localAppConfig.muid || '',
                game_id: getParams('game_id') || localAppConfig.game_id || '',
                platform,
                username: getParams('username') || localAppConfig.username,
                bak: getParams('bak') || localAppConfig.bak,
                model: getParams('model') || localAppConfig.model || '',
            }
            this.$store.dispatch('app/updateAppConfig', appConfig)
            setLocalAppConfig(appConfig)
            console.log('>>> chargeCenter appConfig:', appConfig)

            // 适配 localAccountData逻辑
            const localAccountData = { ...translateUrlParams() }
            delete localAccountData.is_charge_center
            this.$store.dispatch('updateAccountData', localAccountData)
            setLocalAccountData(localAccountData)
            console.log('>>> chargeCenter accountData:', localAccountData)

            // 原初始化逻辑
            this.hidePayForm = false;
            this.payForm = { ...this.payForm, ...localAccountData }
            this.setDefaultAlipay()
        } else {
            // 原支付逻辑
            this.hidePayForm = (window.self === window.top);
            ([
                'server_id',
                'server_name',
                'order_money',
                'pay_money',
                'goods_name',
                'goods_id',
                'role',
                'role_id',
                'data',
                'ext',
                'pay_sign',
                'timestamp',
            ]).forEach(key => {
                this.$set(this.payForm, key, getParams(key))
            })
            this.setDefaultAlipay()
            // this.doGetCouponList() // 获取可用优惠券
        }
        
        if(isWechatEnv){
            const messageListener = async ({ data }) => {
                console.error("payment-frames",data)
                // 监听并接收frame中游戏的支付信息
                if (data.key == 'hidePayForm') {
                    this.hidePayForm = true
                    window.removeEventListener('message', messageListener)
                }else{
                    console.log('payment-frame receive message data without handle: ', data)
                }
            }
            window.addEventListener('message', messageListener, false)
        }
    },
}
</script>

<style scoped lang="scss">
.charge-center__header {
    background-color: var(--theme-color);
    color: $white;
    padding: 12px;
    position: relative;
}

.charge-center-container {
    background-color: #eeeeee;
    height: 100%;
}

.charge-center-container ::v-deep .van-popup__close-icon {
    /* 强制覆盖 van-icon 的样式 */
    color: #000000 !important;
}

.cell-container {
    border-radius: 8px;
    border: 1px solid var(--border-color);
}

.custom-pay-icon {
    width: 28px;
    height: 28px;
    object-fit: contain;
    display: block;
}

.c-check {
    border: 2px solid #c49947;
}

.c-title {
    font-size: 16px;
    margin-top: 26px;
    font-weight: bold;
    color: gray;
}

.card-container {
  height: calc(100vh - 340px);
  overflow-y: auto;
}

.card {
  display: flex;
  flex-direction: row;
  padding: 12px;
  background-color: #fff;
  border-radius: 10px;
  margin-top: 12px;
  font-size: 14px;
}

.card-left {
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #d6d6d6;
  padding: 8px;
}

.left-body {
  text-align: center;
}

.left-money {
  font-size: 36px;
  font-weight: bold;
}

.currency {
  font-size: 20px;
}

.left-tip {
  font-size: 16px;
}

.card-right {
  flex: 1;
  padding: 8px 20px;
}

.right-title {
  font-weight: bold;
  font-size: 15px;
  margin-right: 6px;
}

.right-time {
  margin: 6px 0;
}

.b-text {
  text-align: center;
  font-size: 14px;
  line-height: 50px;
  color: gray;
}

.orange {
  color: #c49947;
}
</style>
